import { Navigate, useLocation } from 'react-router-dom';
import useAuthStore from '../store/authStore';

export default function RequireAuth({ children }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const loading = useAuthStore((s) => s.loading);
  const location = useLocation();

  if (loading) {
    return <div style={{ height: '100vh', display: 'grid', placeItems: 'center' }} className="muted">Carregando…</div>;
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}
